import { DatePipe } from '@angular/common';
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { forkJoin, Subscription } from 'rxjs';
import { ApiConstants } from 'src/app/constants/api-constants';
import { EntityAlertsCountPayloadModel } from 'src/app/model';
import { CaseServiceService } from 'src/app/modules/case/case-service.service';
import { EventsServiceService } from 'src/app/modules/events/events-service.service';
import { DataService, ServicecallService } from 'src/app/services';
import { EntitiesServiceService } from '../../services';
import { TelemetryDownloadPopoverComponent } from '../telemetry-download-popover/telemetry-download-popover.component';

@Component({
  selector: 'app-alert-analyze',
  templateUrl: './alert-analyze.component.html',
  styleUrl: './alert-analyze.component.css'
})
export class AlertAnalyzeComponent implements OnInit, OnChanges {

  @Input() alertDetails: any;
  @Input() pageType: string;
  @Input() fromDate : any;
  @Input() toDate : any;

  severity = new FormControl();
  category = new FormControl();

  masterMapData: any = [];
  selectedIndex: number = 0;
  alertAnalyzeTelemetryTab: any[] = [];
  alertAnalyzeConfig: any;
  telemetryDetails: any;
  vehicleState: string;
  severityList: { name: string, value: string }[] = [];
  categoryList: { name: string, value: string }[] = [];
  widgetStatusColorConfig: any;
  showComments: boolean = false;
  commentsList: any[] = [];
  telemetryAttributesData: any;
  teleHistoryConfig: any;
  aggrData: any;

  private _trackEntitySubscription: Subscription;
  private _tenantConfig: any;
  private _entitiesMarkerList: any;
  private _updateAlertSubscription: Subscription;
  private _trackEntityAlertsCountSubscription: Subscription;
  private _alterMasterList: any = [];
  private _dtcCaseCount: any = [];
  private _entitiesAggrSubscription: Subscription;

  constructor(private _dataService: DataService, private _service: EventsServiceService, public dialog: MatDialog,
    private _caseService: CaseServiceService, private _sharedService: ServicecallService, private _datePipe: DatePipe, private _entityService: EntitiesServiceService
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges() : void {
    this.showComment(false);
    this._setConfigurations();
    this.getEntitiesTrackdetails();
    this._initializeFormFields();
  }

  ngOnDestroy(): void {
    this._trackEntitySubscription?.unsubscribe();
    this._updateAlertSubscription?.unsubscribe();
    this._trackEntityAlertsCountSubscription?.unsubscribe();
    this._entitiesAggrSubscription?.unsubscribe();
  }

  /**
   * Handles back
   */
  handleBack() {
    this._dataService?.broadcast('hideAlertAnalyze', { tab: this.pageType });
  }

  /**
   * Sets severity colors
   * @param type 
   * @returns  
   */
  setSeverityColors(type: string) {
    return type === 'text' ? this.widgetStatusColorConfig?.find(list => list?.type === this.alertDetails?.severity)?.markerColor
      : this.widgetStatusColorConfig?.find(list => list?.type === this.alertDetails?.severity)?.bgColor;
  }

  /**
   * Shows comment
   * @param show 
   */
  showComment(show: boolean) {
    const reqPayload = {
      module: 'events',
      moduleId: this.alertDetails?.id
    }
    this._caseService.getCommentsList(reqPayload)?.subscribe(
      {
        next: (response: any) => {
          if (response) {
            this.commentsList = [...response];
            this.showComments = show;
          }
        }, error: (error: any) => {
          this._sharedService.toasterService({
            type: 'error',
            msg: 'Unable to fetch comments',
          });
        }
      });
  }

  /**
   * Opens download popover
   */
  openDownloadPopover() {
    this.dialog.open(TelemetryDownloadPopoverComponent, {
      data: { msg: 'Download', details: this.alertDetails, fuelType: this.masterMapData[0]?.fuelType },
      disableClose: true
    });
  }

  /**
   * Fetchs state
   * @param status 
   * @param state 
   * @returns  
   */
  fetchAlertState(status: string, state: string) {
    if (status === 'Active') {
      return status
    } else if (state === 'invalid') {
      return 'Invalid'
    } else {
      return 'Valid'
    }
  }

  /**
   * Fetchs vehicle state
   * @param state 
   * @returns  
   */
  fetchVehicleState(state: string) {
    const vehicleStateConfig = this._sharedService?.getConfiguration('tenantGenericConfig')?.trackerVehicleStateWidgets ?? [];
    return vehicleStateConfig?.find((item: any) => item?.state === state)?.name;
  }

  /**
   * Tabs changed
   * @param event 
   */
  tabChanged(event: MatTabChangeEvent) {
    this.getEntitiesTelemetryAttributes(event?.index)
  }

  /**
   * Validates alert
   * @param type 
   */
  validateAlert(type: string) {
    const reqData = {
      status: false,
      id: this.alertDetails?.id,
      state: type === 'invalid' ? type : null,
      severity: this.severity?.value,
      category: this.category?.value
    }
    this._updateAlertSubscription = this._service?.updateAlert(reqData)?.subscribe((result: any) => {
      if (result['status']) {
        this._dataService?.broadcast('hideAlertAnalyze', { tab: this.pageType });
        this._sharedService?.toasterService({ type: 'success', msg: result["response"] });
      }
    })
  }

  
  /**
 * Gets entitiesdetials
 */
   getEntitiesTelemetryAttributes(tabIndex?: number) {
    const payload = {
      siteId: this._sharedService.getSiteId(),
      ...(this._setFromAndToTime(tabIndex)),
      entityId: this.alertDetails?.entityId
    };
    this._trackEntitySubscription = this._sharedService.trackEntity(payload, 1).subscribe({
      next: (result: any) => {
        if (result['status']) {
          if (result['response']['data']?.length) {
            const tableData = [...result['response']['data']]?.find((item: any) => Object.keys(item)?.includes('original'));
            this.telemetryAttributesData = tableData ? tableData.original : [];
            let originalTime;
            if (this.telemetryAttributesData?.length) {
              this.telemetryAttributesData?.map((item: any) => {
                item.time = this._sharedService.getLastSeenFormat(item?.sourceTimestamp);
                item.attributeList = item.attributes ? item.attributes.map((elem: any) => { return elem?.attributeName?.toString() + ':' + elem?.attributeValue?.toString() })?.toString() : null;
              });
              originalTime = this.telemetryAttributesData?.[0]?.time;
              this.teleHistoryConfig = this._sharedService.getAlertAnalyzeTelemetryConfig(this.masterMapData?.[0]?.fuelType) ?? [];
              const attributeList = this.teleHistoryConfig?.[0]?.telemetryDataAttributes;
              let mappedData;
              mappedData = attributeList?.map(attr => {
                const matchingAttribute = this.telemetryAttributesData?.[0]?.attributes?.find(item =>
                  item?.attributeName === attr?.name
                );
                return {
                  attributeName: attr.attributeName,
                  value: matchingAttribute?.attributeValue?.toFixed(3) ?? null
                };
              });
              this.telemetryAttributesData = mappedData;
            }
            this.telemetryAttributesData?.map(item => {
              if (item?.attributeName === 'Time') {
                item.value = originalTime;
              }
            })

          } else {
            this.telemetryAttributesData = [];
          }
        }
        else {
          this.telemetryAttributesData = [];
        }
      },
      error: (error) => {
        this._sharedService?.toasterService({ type: 'error', msg: error?.message })
      }
    });
  }

  /**
* Gets entitiesdetials
*/
  getEntitiesTrackdetails(type: string = 'default') {
    let configStartDate = null;
    let configEndDate = null;
    if (this._tenantConfig?.defaultTimeRange) {
      const configHour = this._tenantConfig?.defaultTimeRange || 0;

    const { startDate, endDate } = this._sharedService.calculateDateRange(configHour);
      configEndDate = endDate;
      configStartDate = startDate;
    }
    const payload = {
      siteId: this._sharedService.getSiteId(),
      to: this._datePipe.transform(Date.now(), 'yyyy-MM-ddTHH:mm:ssZZ'),
      entityId: this.alertDetails?.entityId
    };
    const alertsCountPayload: Partial<EntityAlertsCountPayloadModel> = {
      siteId: this._sharedService.getSiteId(),
      from: this._datePipe.transform(this.fromDate ?? configStartDate, 'yyyy-MM-ddTHH:mm:ssZZ'),
      to: this._datePipe.transform(this.toDate ?? Date.now(), 'yyyy-MM-ddTHH:mm:ssZZ'),
      entityCategory: this.alertDetails?.entityCategory,
    };
    const dtcCountPayload = {
      entityIds: [this.alertDetails?.entityId],
      range : {
        from: this._datePipe.transform(this.fromDate ?? configStartDate, 'yyyy-MM-ddTHH:mm:ssZZ'),
        to: this._datePipe.transform(this.toDate ?? Date.now(), 'yyyy-MM-ddTHH:mm:ssZZ'),
      }

    };

    this._trackEntitySubscription = this._sharedService.trackEntity(payload, 1).subscribe({
      next: (result: any) => {
        if (result['status']) {
          if (result['response']['data']?.length) {
            const tableData = [...result['response']['data']]?.find((item: any) => Object.keys(item)?.includes('original'));
            this.masterMapData = tableData ? tableData.original : [];
            if (this.masterMapData?.length) {
              this.masterMapData?.map((item: any) => {
                item.coordinates = (item.coordinates ? Object.keys(item.coordinates).length : null) ? Object.values(item.coordinates) : null;
                item.time = this._sharedService.getLastSeenFormat(item?.sourceTimestamp);
                item.location = (item.coordinates ? Object.keys(item.coordinates).length : null) ? Object.values(item.coordinates).toString() : null;
                item.singleTracker = false;
                item.image = item.entityImage ? item.entityImage : this._setMarkerImage(item.entityCategory);
                item.markerImg = this._setMarkerImage(item.entityCategory);
                item.entityType = 'tracker';
                item.attributeList = item.attributes ? item.attributes.map((elem: any) => { return elem?.attributeName?.toString() + ':' + elem?.attributeValue?.toString() })?.toString() : null;
                item.apiType = type;
                item.attributes?.forEach((elem: any) => {
                  item['attribute.' + elem.attributeName] = elem.attributeValue;
                });
              });
              this.masterMapData = this.masterMapData.map((data: any) => {
                const { secondaryDetails, primaryDetails, ...rest } = data;
                return {
                  ...rest,
                  ...secondaryDetails,
                  ...primaryDetails
                };
              });
              this.vehicleState = this.masterMapData?.[0]?.['attribute.derived.vehicleState']
              if (this.masterMapData?.length) {
                this.masterMapData?.map(item => {
                  item.trackerType = "vehicleValidOps";
                  item.alertCoordinate = [this.alertDetails?.latitude, this.alertDetails?.longitude];
                  item.severity = this.alertDetails?.severity;
                  this._calculateAggregate();
                });
              }
            }
            this._sharedService.setLeafletData(this.masterMapData);
            this.getEntitiesTelemetryAttributes(0);
          } else {
            this.masterMapData = [];
          }
        }
        else {
          this.masterMapData = [];
        }
      },
      error: (error) => {
        this._sharedService?.toasterService({ type: 'error', msg: error?.message })
      }
    })

    this._trackEntityAlertsCountSubscription = forkJoin([
      this._sharedService.alertsCount(alertsCountPayload),
      this._sharedService.getActiveDtcCaseCount(dtcCountPayload)
    ]).subscribe((result: any) => {
      if (result[0]['status'] && result[1]['status']) {
        
        if (result[0]['response']['data'].length) {
          this._alterMasterList = [...result[0]['response']['data']];
          if (this._alterMasterList.length && this.masterMapData.length) {
            this._alterMasterList.forEach((elem: any) => {
              this.masterMapData.map((item: any) => {
                if (item.entityId === elem.entityId) {
                  item.alertDetails = elem.alertDetails;
                  item.totalAlertCount = '' + elem.totalAlertsCount;
                  item.alertName = elem.alertDetails.map(({ alertName }) => alertName).toString();
                  item.alertNumber = elem.alertDetails.map(({ alertId }) => alertId).toString();
                  item.isAlertMarker = true;
                }
                !item.totalAlertCount ? item.totalAlertCount = '' : null;
                !item.alertName ? item.alertName = '' : null;
              });
            });
          }
        } else {
          this._alterMasterList = [];
          this._mapAlertNoData();
        }
        if (result[1]?.length) {
          this._dtcCaseCount = [...result[1]];
          if (this._dtcCaseCount.length && this.masterMapData.length) {
            this._dtcCaseCount?.forEach((elem: any) => {
              this.masterMapData?.map((item: any) => {
                if (item.entityId === elem.entityId) {
                  item.dtcCase = elem.count;
                }
                !item.dtcCase ? item.dtcCase = '' : null;
              });
            });
          }
        } else {
          this._dtcCaseCount = [];
          this._mapDtcNoData();
        }
        this.masterMapData = [this.masterMapData?.[0]];
      }
    });
  }

  private _setConfigurations() {
    this._tenantConfig = this._sharedService.getConfiguration('tenantGenericConfig') ? this._sharedService.getConfiguration('tenantGenericConfig') : null;
    this._entitiesMarkerList = this._sharedService.getConfiguration('trackerEntities') ? this._sharedService.getConfiguration('trackerEntities')['trackerEntitiesList'] : [];
    this.alertAnalyzeConfig = this._tenantConfig?.alertAnalyze ? this._tenantConfig?.alertAnalyze : null;
    this.alertAnalyzeTelemetryTab = this.alertAnalyzeConfig?.alertAnalyzeTelemetryTab ?? [];
    this.telemetryDetails = this.alertAnalyzeConfig?.telemetryDetails ?? {};
    this.severityList = this.alertAnalyzeConfig?.severityList;
    this.categoryList = this.alertAnalyzeConfig?.categoryList;
    this.widgetStatusColorConfig = this._sharedService.getConfiguration('widgetStatusColor')?.widgetStatusColor;
  }

  /**
   * Initializes form fields
   */
  private _initializeFormFields() {
    this.severity?.setValue(this.alertDetails?.severity);
    this.category?.setValue(this.alertDetails?.category);
  }

  /**
   * Sets from and to time
   * @param tabIndex 
   * @returns  
   */
  private _setFromAndToTime(tabIndex: number) {
    if (tabIndex === 0)
      return {
        to: this._datePipe.transform(
          new Date(new Date(this.alertDetails?.originalTime).getTime() - 1),
          'yyyy-MM-ddTHH:mm:ssZZ'
        )
      }
    else if (tabIndex === 1) {
      return {
        to: this._datePipe.transform(this.alertDetails?.originalTime, 'yyyy-MM-ddTHH:mm:ssZZ')
      }
    } else {
      return {
        to: this._datePipe.transform(Date.now(), 'yyyy-MM-ddTHH:mm:ssZZ')
      }
    }
  }

  /**
   * Maps alert no data
   */
  private _mapAlertNoData() {
    if (this.masterMapData.length) {
      this.masterMapData.map((item: any) => {
        item.alertDetails = '';
        item.totalAlertCount = '';
        item.alertName = '';
        item.alertNumber = '';
        item.isAlertMarker = false;
      });
    }
  }

  /**
   * Maps dtc no data
   */
  private _mapDtcNoData() {
    if (this.masterMapData.length) {
      this.masterMapData.map((item: any) => {
        item.dtcCase = '';
      });
    }
  }

  /**
   * Sets marker image
   * @param category 
   * @returns  
   */
  private _setMarkerImage(category: any) {
    const filteredImgList = this._entitiesMarkerList.find((entity: any) => entity.entityCategory === category);
    return filteredImgList ? (this._tenantConfig?.tenant === 'VOT' ? filteredImgList?.imgUrl : filteredImgList?.imgUrl + ApiConstants.blobSasToken) : 'assets/images/passenger-car.svg';
  }

  /**
   * Calculates aggregate
   */
  private _calculateAggregate() {
    let configStartDate = null;
    let configEndDate = null;
    if (this._tenantConfig?.defaultTimeRange) {
      const configHour = this._tenantConfig?.defaultTimeRange || 0;

    const { startDate, endDate } = this._sharedService.calculateDateRange(configHour);
      configEndDate = endDate;
      configStartDate = startDate;
    }

    const reqPayload: { entityIds: string[]; from: string; to: string; } = {
      entityIds: this.masterMapData?.map((item) => item?.entityId),
      from: this._datePipe.transform(this.fromDate ?? configStartDate, 'yyyy-MM-ddTHH:mm:ssZZ'),
      to: this._datePipe.transform(this.toDate ?? Date.now(), 'yyyy-MM-ddTHH:mm:ssZZ'),
    };
    this._entitiesAggrSubscription = this._entityService.getEntityAggrLatestList(reqPayload, false)?.subscribe((result: any) => {
      this.aggrData = result?.length ? result : [];
      this.masterMapData = [...this.masterMapData.map((element: any) => {
        const matchedItem = this.aggrData?.find((item: any) => item?.entityId === element?.entityId);

        if (matchedItem) {
          const trimmedTotalDistance = Number(matchedItem.totalDistance)?.toFixed(1);
          const totalEnginehoursTrimmed = Number(matchedItem.totalEnginehours)?.toFixed(1);

          return {
            ...element,
            aggrDetails: {
              ...matchedItem,
              trimmedTotalDistance,
              totalEnginehoursTrimmed,
            },
          };
        } else {
          return { ...element, aggrDetails: null };
        }
      })];
      this._sharedService.setLeafletData(this.masterMapData);
    });
  }
}
